import _ from 'underscore';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function PaymentProfileCtrl($window, $q, jsSdkPaymentProfile, analyticsService, TRACKING_EVENT_CATEGORIES, organizationService, jsSdkUtils) {
  const PROVIDER_TYPE = 'STRIPE';

  const stripeClient = $window.Stripe.card;
  const currentUserOrganization = organizationService.getCurrentOrganization();
  const vm = this;

  vm.showAdditionalPaymentProfiles = false;
  vm.showAddPayment = false;
  vm.paymentProfiles = [];
  vm.cardForm = {};

  _activate();

  /******************************/

  vm.selectProfile = function (selected) {
    _setDefaultPaymentProfile(selected)
      .then(() => {
        const trackingData = {
          cardType: selected.cardType,
          last4: selected.last4,
          paymentProfileId: selected._id
        };

        _trackSetPaymentProfile(trackingData);
      })
      .then(() => _getPaymentProfiles())
      .then(() => _showLoadSpinner(false));
  };

  vm.addProfile = function () {
    _handleError();
    _showPaymentForm(true);
  };

  vm.submitForm = function () {
    return _tokenizeCard(vm.cardForm)
      .then(token => {
        _showLoadSpinner(true);

        return _addPaymentProfile(token)
          .then(() => _showPaymentForm(false))
          .then(() => _getPaymentProfiles())
          .then(() => _showLoadSpinner(false))
          .then(() => {
            vm.showAdditionalPaymentProfiles = true;
          }) //If a user has added a new profile, make sure you show all options
          .then(() => _resetForm());
      })
      .catch(err => {
        _handleError(err);
        _showLoadSpinner(false);
      });
  };

  /******** Helpers *************/
  function _activate() {
    _showLoadSpinner(true);
    _getPaymentProfiles()
      .then(() => _showPaymentForm(!_hasPaymentProfiles()))
      .catch(err => _handleError(err))
      .finally(() => _showLoadSpinner(false));
  }

  function _tokenizeCard(values) {
    return $q((resolve, reject) => {
      const options = {
        number: values.ccNumber,
        cvc: values.ccCvc,
        exp_month: values.ccExpMonth,
        exp_year: values.ccExpYear,
        address_zip: values.postalCode
      };

      stripeClient.createToken(options, (status, response) => {
        if (response.error) return reject(response.error);
        return resolve(response.id);
      });
    });
  }

  function _addPaymentProfile(nonce) {
    const options = {
      paymentMethodNonce: nonce,
      providerType: PROVIDER_TYPE
    };

    return jsSdkPaymentProfile.createByOrganizationId(currentUserOrganization.id, options)
      .then(response => {
        const trackingData = {
          cardType: response.cardType,
          last4: response.last4,
          paymentProfileId: response._id
        };

        if (vm.callback) {
          vm.callback(response);
        }

        _trackAddPaymentProfile(trackingData);
      });
  }

  function _trackSetPaymentProfile(options) {
    options = options || {};
    options.category = TRACKING_EVENT_CATEGORIES.BILLING;

    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.SET_PAYMENT_PROFILE, options);
  }

  function _trackAddPaymentProfile(options) {
    options = options || {};
    options.category = TRACKING_EVENT_CATEGORIES.BILLING;

    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.ADD_PAYMENT_PROFILE, options);
  }

  // Set the selected Payment Profile as the user's default
  function _setDefaultPaymentProfile(paymentProfile) {
    _showLoadSpinner(true);
    return jsSdkPaymentProfile.setDefaultByIdAndOrganizationId(paymentProfile.id, currentUserOrganization.id)
      .catch(err => {
        _showLoadSpinner(false);
        _handleError(err);
      });
  }

  // Load user's existing payment profiles.
  function _getPaymentProfiles() {
    return jsSdkPaymentProfile.listByOrganizationId(currentUserOrganization.id, {
        providerType: PROVIDER_TYPE
      })
      .then(resp => {
        if (resp && resp.length) {
          return _findDefaultPaymentProfile(resp)
            .then(paymentProfile => {
              vm.paymentProfile = paymentProfile;

              return _sortPaymentProfiles(resp);
            })
            .then(paymentProfiles => {
              // Ensure that the default is always in the payment profiles returned
              if (_.indexOf(paymentProfiles, vm.paymentProfile) < 0) {
                paymentProfiles.push(vm.paymentProfile);
              }
              vm.paymentProfiles = paymentProfiles;
            });
        }

        return null;
      });
  }

  /******** Setup Helpers *************/
  function _resetForm() {
    vm.cardForm = {};
  }

  function _handleError(err, message) {
    if (message) {
      vm.formError = `${message} - Please try again.`;
    } else if (err) {
      const error = jsSdkUtils.getErrorFromResponse(err) || 'Error processing card';
      vm.formError = `${error} - Please try again.`;
    } else {
      vm.formError = null;
    }
  }

  function _showPaymentForm(showForm) {
    vm.showAddPayment = showForm;
  }

  function _showLoadSpinner(showSpinner) {
    vm.loading = !!showSpinner;
  }

  function _hasPaymentProfiles() {
    return vm.paymentProfiles ? !!vm.paymentProfiles.length : false;
  }

  function _findDefaultPaymentProfile(paymentProfiles) {
    return $q(resolve => {
      const profile = _.find(paymentProfiles, {
        default: true
      });

      // Or return the most recent
      resolve(profile || _.last(paymentProfiles));
    });
  }

  function _sortPaymentProfiles(paymentProfiles) {
    return $q(resolve => {
      resolve(_.sortBy(paymentProfiles, profile => {
        return profile.modified;
      }).reverse().slice(0, 4));
    });
  }
}

PaymentProfileCtrl.$inject = [
  '$window',
  '$q',
  'jsSdk.paymentProfile',
  'analyticsService',
  'TRACKING_EVENT_CATEGORIES',
  'organizationService',
  'jsSdk.utils'
];

export default PaymentProfileCtrl;



// WEBPACK FOOTER //
// ./src/directives/paymentProfile/controller.js